export class ProductType {

    code: string = '';

    name: string = '';

    constructor(code: string = '', name: string = '') {
        this.code = code;
        this.name = name;
    } 

    public toString(): string {

        return this.name;
        
    }

    public static transformAnonymous(productType: any): ProductType {

        if (!productType) { // if the parameter is null
            return new ProductType(); // return empty product type
        }

        return new ProductType (
            productType.code ?? '',
            productType.name ?? ''
        );

    }

}
